export default __webpack_public_path__ + "i.png";